import { Component, OnInit, inject } from '@angular/core';
import { BackendDataSourceService } from '@ntap/core';
import { ArhivskaKlasifikacijaProvider } from './arhivska-klasifikacija-provider';
import { Observable } from 'rxjs';
import { CommonFormComponent } from '@ntap/common';

@Component({
  selector: 'app-arhivska-klasifikacija',
  templateUrl: './arhivska-klasifikacija.component.html',
  styleUrls: ['./arhivska-klasifikacija.component.scss'],
  providers: [ArhivskaKlasifikacijaProvider]
})
export class ArhivskaKlasifikacijaComponent
  extends CommonFormComponent
  implements OnInit
{
  backendDataSourceService = inject(BackendDataSourceService);
  arhivskeOznakeProvider = inject(ArhivskaKlasifikacijaProvider);
  selectedNodes: any;

  arhivskeOznakeArray: Observable<any>;

  override doChangedInputParam(): void {
    this.initComponentData(this.inputParam);
    this.formControl =
      this.formService.getFormControl(this.formControlName) || this.formControl;
    if (this.inputParam.itemValue !== undefined) {
      this.formControl.setValue(this.inputParam.itemValue);
      this.currentValue = this.inputParam.itemValue;
    }
    this.formControlInitialized = true;
    this.formControl.markAsPristine();
  }

  ngOnInit() {
    this.arhivskeOznakeArray = this.arhivskeOznakeProvider.getArhivskeOznake();

    //IF ARHIVSKA OZNAKA ALREADY EXISTS SET TREESELECT COMPONENT selectedNodes VALUE TO arhivskeOznakeArray$ OBJECT THAT MATCHES ID
    const arhivskaOznakaValueExists = this.formControl.value != null;
    const existingArhivskaOznakaId: number = this.formControl.value;

    if (arhivskaOznakaValueExists) {
      this.arhivskeOznakeArray.subscribe((arhivskeOznakeArray: any) => {
        this.selectedNodes = findObjectOfArhivskeOznake(
          arhivskeOznakeArray,
          existingArhivskaOznakaId
        );
      });
    }
  }

  onNodeSelect(event: any) {
    //SET formControl VALUE ON TREESELECT COMPONENT CHANGE
    this.setValue(event.node.data);
  }

  onClear() {
    this.setValue(null);
  }
}

function findObjectOfArhivskeOznake(
  arhivkseOznake: any,
  existingArhivskeOznakeId: number
): any {
  for (const arhivskaOznaka of arhivkseOznake) {
    if (arhivskaOznaka.data === existingArhivskeOznakeId) {
      return arhivskaOznaka;
    }
    if (arhivskaOznaka.children) {
      const found = findObjectOfArhivskeOznake(
        arhivskaOznaka.children,
        existingArhivskeOznakeId
      );
      if (found) {
        return found;
      }
    }
  }
  return null;
}
